module.exports = __webpack_public_path__ + "static/media/quick_filter.35244fdb.svg";